import type { Trait } from '@atlassian/jira-personalization-service';
import { EXPERIENCE_TYPE, PERSONA_TYPE, type PersonaExperience } from '../../model/types';

export const mapPersonaTraitsToExperience = (
	userTraitsPersona?: Trait,
): PersonaExperience | undefined => {
	switch (userTraitsPersona?.value) {
		case PERSONA_TYPE.MARKETING_GENERIC:
		case PERSONA_TYPE.CAMPAIGN_MARKETING_LEAD:
			return EXPERIENCE_TYPE.MARKETER_LEAD;
		case PERSONA_TYPE.PROJECT_MARKETING_LEAD:
			return EXPERIENCE_TYPE.MARKETER_PROJECT;
		case PERSONA_TYPE.CONTENT_MARKETING_LEAD:
			return EXPERIENCE_TYPE.MARKETER_CONTENT;
		case PERSONA_TYPE.PMM:
			return EXPERIENCE_TYPE.MARKETER_PMM;
		default:
			return undefined;
	}
};
